import { requestJSON } from "../utils/request-module"

const getCompiledReal = async function ({ files, mainContract, mainFile,compilerVersion, compilerSettings={} }) {
  if(compilerSettings && !compilerSettings.viaIR) {
    delete compilerSettings.viaIR
  }
  return await requestJSON("POST", "/get-compiled", {
    files,
    mainContract,
    mainFile,
    compilerVersion,
    compilerSettings
  })
}
//@ts-ignore why lodash error?
var getCompiledMemoized = require("lodash").memoize(getCompiledReal, function () {
  return JSON.stringify(arguments)
})
export default getCompiledMemoized